import React from 'react';
import { getRandomString } from 'utils/general';

class BouncingSpinner extends React.Component {
  id: string;

  constructor(props: any) {
    super(props);

    this.id = getRandomString(7);
  }

  render(): React.ReactNode {
    const { id } = this;

    return (
      <div>
        <style>
          {`
          .spinner-${this.id} {
            width: 70px;
            text-align: center;
          }

          .spinner-${this.id} > div {
            width: 18px;
            height: 18px;
            background-color: var(--color-primary-dark);

            border-radius: 100%;
            display: inline-block;
            -webkit-animation: sk-bouncedelay 1.4s infinite ease-in-out both;
            animation: sk-bouncedelay 1.4s infinite ease-in-out both;
          }

          .spinner-${this.id} .bounce1 {
            -webkit-animation-delay: -0.32s;
            animation-delay: -0.32s;
          }

          .spinner-${this.id} .bounce2 {
            -webkit-animation-delay: -0.16s;
            animation-delay: -0.16s;
          }

          @-webkit-keyframes sk-bouncedelay {
            0%, 80%, 100% { -webkit-transform: scale(0) }
            40% { -webkit-transform: scale(1.0) }
          }

          @keyframes sk-bouncedelay {
            0%, 80%, 100% { 
              -webkit-transform: scale(0);
              transform: scale(0);
            } 40% { 
              -webkit-transform: scale(1.0);
              transform: scale(1.0);
            }
          }
          `}
        </style>
        <div className={`spinner-${id}`}>
          <div className="bounce1" />
          <div className="bounce2" />
          <div className="bounce3" />
        </div>
      </div>
    );
  }
}

export default BouncingSpinner;
